import { render } from "./SampleSubmission.vue?vue&type=template&id=643e4d57&scoped=true"
import script from "./SampleSubmission.vue?vue&type=script&lang=js"
export * from "./SampleSubmission.vue?vue&type=script&lang=js"

import "./SampleSubmission.vue?vue&type=style&index=0&id=643e4d57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643e4d57"]])

export default __exports__